interface GlobalConfig {
  googleApiKey: string | null;
  host: string | null;
}

declare global {
  interface Window {
    scoutConfig: {
      googleApiKey: string;
      host: string;
    };
  }
}

export const getGlobalConfig = (): GlobalConfig => ({
  googleApiKey: window.scoutConfig?.googleApiKey || null,
  host: window.scoutConfig?.host || null
});
